import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import constants from "../../constants/User/user";
import { useUser } from "../../context/userContext";
import { useAlert } from "../../context/Feedback/alertContext";
import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/material-dashboard-react/components/dialogHowToUse";
import "./classes.css";

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";

import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import CheckIcon from "@material-ui/icons/Check";
import "./userDialog.css";
import DataService from "services/DataService";
const useStyles = makeStyles(styles);

export default function UserDialog() {
  const {
    isActiveUserDialog,
    setActiveUserDialog,
    user,
    setUser,
    language,
    credential,
  } = useUser();
  const { setAlert } = useAlert();
  const [checked, setChecked] = useState(true);
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const classes = useStyles();

  const handleClose = () => {
    setPassword("");
    setActiveUserDialog(false);
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const populateFields = () => {
    setFirstName(user.firstname);
    setLastName(user.lastname);
  };

  const updateUser = async (event) => {
    event.preventDefault();
    if (password.length !== 0) {
      try {
        let usr = {};
        usr.email = user.email;
        usr.name = user.name;
        usr.firstname = firstname ? firstname : user.firstname;
        usr.lastname = lastname ? lastname : user.lastname;
        usr.autho = password;
        const authorization = {
          headers: {
            Authorization: credential,
          },
        };
        const response = await DataService.updateUser(usr, authorization);
        setUser(response.data);

        setPassword("");
        setAlert({
          active: true,
          text: constants.alerts.succeed[language],
          color: "success",
          sevarity: "info",
          icon: CheckIcon,
        });
      } catch (e) {
        setAlert({
          active: true,
          text: constants.alerts.wrongPass[language],
          color: "info",
          sevarity: "info",
        });
      }
    } else {
      setAlert({
        active: true,
        text: constants.alerts.requiredPass[language],
        color: "info",
        sevarity: "info",
      });
    }
  };

  return (
    <div>
      <Dialog
        TransitionProps={{
          onEntered: () => {
            populateFields();
          },
        }}
        checked={checked}
        onChange={handleChange}
        open={isActiveUserDialog}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle className={classes.dialog} id="alert-dialog-slide-title">
          <div className="wrapper-title">
            {constants.modal.profile[language]}
            <div className="wrapper-button-close">
              <Button onClick={handleClose}>X</Button>
            </div>
          </div>
        </DialogTitle>
        <DialogContent className={classes.dialog}>
          <Grid container justifyContent="center">
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader>
                  <h4 className={classes.cardTitleWhite}>
                    {constants.user.editProfile[language]}
                  </h4>
                  <p className={classes.cardCategoryWhite}>
                    {constants.user.creation[language]} {user.dateCreation}
                  </p>
                </CardHeader>
                <CardBody>
                  <form onSubmit={updateUser}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          id="user-name"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            placeholder: user.name,
                            disabled: true,
                            name: "userName",
                            autoComplete: "username",
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          id="email-address"
                          formControlProps={{
                            fullWidth: true,
                            disabled: true,
                          }}
                          inputProps={{
                            value: user.email,
                            autoComplete: "email",
                            name: "userEmail",
                          }}
                        />
                      </GridItem>
                    </GridContainer>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText={constants.user.firstName[language]}
                          onChange={(e) => {
                            setFirstName(e.target.value);
                          }}
                          id="user-dialog-first-name"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            value: firstname,
                            autoComplete: "given-name",
                            name: "firstName",
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText={constants.user.lastName[language]}
                          onChange={(e) => {
                            setLastName(e.target.value);
                          }}
                          id="user-dialog-last-name"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            value: lastname,
                            autoComplete: "family-name",
                            name: "lastName",
                          }}
                        />
                      </GridItem>
                    </GridContainer>
                    <GridContainer>
                      <GridItem>
                        <span>
                          {constants.user.numberOfGrammars[language]}:{" "}
                          {user.historicalGrammar &&
                            user.historicalGrammar.length}
                        </span>
                        <br />
                        <span>
                          {constants.user.numberOfAutomatons[language]}:{" "}
                          {user.historicalMachine &&
                            user.historicalMachine.length}
                        </span>
                      </GridItem>
                    </GridContainer>
                    <GridContainer>
                      <GridItem xs={12} lg={12} sm={12}>
                        <CustomInput
                          onChange={(e) => {
                            setPassword(e.target.value);
                          }}
                          labelText="Senha"
                          id="password"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            type: "password",
                            value: password,
                            required: true,
                            autoComplete: "current-password",
                            name: "password",
                          }}
                        />
                      </GridItem>
                    </GridContainer>
                    <CardFooter
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Button color="success" type="submit">
                        {constants.user.attProfile[language]}
                      </Button>
                    </CardFooter>
                  </form>
                </CardBody>
              </Card>
            </GridItem>
          </Grid>
        </DialogContent>
        <DialogActions className={classes.dialog}></DialogActions>
      </Dialog>
    </div>
  );
}
